export enum PaymentType {
    WAITING, COMPLETED, CANCELED, REFUND_REQUEST, REFUNDED
}

export const PaymentTypeList = [
    {
        type: PaymentType.WAITING,
        name: "결제 대기"
    },
    {
        type: PaymentType.COMPLETED,
        name: "결제 완료"
    },
    {
        type: PaymentType.CANCELED,
        name: "결제 취소"
    },
    {
        type: PaymentType.REFUND_REQUEST,
        name: "환불 요청"
    },
    {
        type: PaymentType.REFUNDED,
        name: "환불 완료"
    }
];

export const getPaymentTypeName = (seq: number) => {
    return PaymentTypeList.find((paymentType) => paymentType.type === seq)?.name;
}

export enum PaymentKeywordType {
    USER, EMAIL, NAME
}

export const PaymentKeywordTypeList = [
    {
        type: PaymentKeywordType.USER,
        name: "사용자명"
    },
    {
        type: PaymentKeywordType.EMAIL,
        name: "이메일"
    },
    {
        type: PaymentKeywordType.NAME,
        name: "결제 항목"
    }
];

export const getPaymentKeywordTypeName = (seq: number) => {
    return PaymentKeywordTypeList.find((keywordType) => keywordType.type === seq)?.name;
}